import React from 'react';
import {
  BackgroundContainer,
  Container,
  ListView,
  DesktopSideNav,
  ListContainer,
  Loader,
  NoDataCard,
  NoDataText,
} from './users-components';
import SideNav from './users-sidenav';
import UserDetails from './users-details';
import UserForm from './users-form';
import {
  useGetUserQuery,
  useGetUserTypesWithRoles,
  useGetTitleCompanies,
} from '@app/graphql';
import { TitleCompanyProps, UserInfo, UserTypes } from '@app/types';
import { Icon } from '@app/components';

const Users = () => {
  const sideNavRef: any = React.useRef(null);
  const [firebaseId, setFirebaseId] = React.useState<string>('');
  const { loading, data } = useGetUserQuery({ firebaseId: firebaseId });
  const [userData, setUserData] = React.useState<UserInfo>();
  const [module, setModule] = React.useState<string>('');
  const [isListLoading, setIsListLoading] = React.useState<boolean>(true);
  const [submittedUser, setSubmittedUser] = React.useState<any>(null);
  const [titleCompanies, setTitleCompanies] = React.useState([]);
  const {
    loading: companiesLoading,
    data: companiesData,
  } = useGetTitleCompanies();
  const [userTypes, setUserTypes] = React.useState<UserTypes[]>([]);
  const {
    loading: userTypeLoading,
    data: userTypeData,
  } = useGetUserTypesWithRoles();

  React.useEffect(() => {
    if (!loading && data && data.user) {
      setUserData(data.user);
    }
    // eslint-disable-next-line
  }, [loading, data]);

  React.useEffect(() => {
    if (
      !companiesLoading &&
      companiesData &&
      companiesData.getAllActiveTitleCompanies
    ) {
      const {
        success,
        titleCompanies,
      } = companiesData.getAllActiveTitleCompanies;
      if (success && titleCompanies && titleCompanies.length) {
        setTitleCompanies(
          titleCompanies.map((titleComapany: TitleCompanyProps) => {
            return { label: titleComapany.name, value: titleComapany._id };
          }),
        );
      }
    }
  }, [companiesLoading, companiesData]);

  React.useEffect(() => {
    if (!userTypeLoading && userTypeData) {
      if (
        userTypeData &&
        userTypeData.getUserTypesWithRoles &&
        userTypeData.getUserTypesWithRoles.success &&
        userTypeData.getUserTypesWithRoles.userTypes
      ) {
        const { userTypes } = userTypeData.getUserTypesWithRoles;
        setUserTypes(
          userTypes.map((userType: any) => {
            return { ...userType, label: userType.name, value: userType._id };
          }),
        );
      }
    }
  }, [userTypeLoading, userTypeData]);

  const onUserSelect = (userFirebaseId: string) => {
    if (userFirebaseId) {
      setFirebaseId(userFirebaseId);
      setModule('userDetail');
    } else {
      setUserData(undefined);
      setFirebaseId('new_firebaseId');
      setModule('');
    }
  };
  const onAddUserClick = () => {
    setUserData(undefined);
    setFirebaseId('new_firebaseId');
    setModule('userAdd');
  };

  const onListLoaded = () => {
    setIsListLoading(false);
  };
  const onCancelUserClick = () => {
    setModule('userDetail');
    if (userData) {
      setUserData(userData);
    } else {
      sideNavRef.current.selectFirstUser();
    }
  };

  const onDeleteUser = (userData: any) => {
    setSubmittedUser(userData);
  };

  const onEditUserClick = () => {
    setModule('userEdit');
    setUserData(userData);
  };

  const onUserSubmit = (userData: any) => {
    setUserData(userData.user);
    setSubmittedUser(userData);
    setModule('userDetail');
  };

  return (
    <>
      <BackgroundContainer>
        <Container>
          <DesktopSideNav>
            <SideNav
              ref={sideNavRef}
              onUserSelect={onUserSelect}
              onAddUserClick={onAddUserClick}
              onListLoaded={onListLoaded}
              submittedUser={submittedUser}
              userTypes={userTypes}
              titleCompanies={titleCompanies}
            />
          </DesktopSideNav>
          <ListView>
            {(loading || isListLoading) && module !== 'userAdd' ? (
              <Loader>
                <Icon name="loader" />
              </Loader>
            ) : (
              <>
                {!loading && module === '' && (
                  <NoDataCard>
                    <NoDataText>No user found for your search.</NoDataText>
                  </NoDataCard>
                )}
                <ListContainer>
                  {module === 'userDetail' && (
                    <UserDetails
                      userDetails={userData}
                      onEditUserClick={onEditUserClick}
                      onDeleteUser={onDeleteUser}
                    />
                  )}
                  {(module === 'userAdd' || module === 'userEdit') && (
                    <UserForm
                      onCancelUserClick={onCancelUserClick}
                      userDetails={module === 'userAdd' ? undefined : userData}
                      onUserSubmit={onUserSubmit}
                      userTypes={userTypes}
                      titleCompanies={titleCompanies}
                    />
                  )}
                </ListContainer>
              </>
            )}
          </ListView>
        </Container>
      </BackgroundContainer>
    </>
  );
};

export default Users;
